import React from 'react';
import { cn } from '../../lib/cn';

interface MastheadProps {
  title: React.ReactNode;
  summary?: React.ReactNode;
  meta?: React.ReactNode;      // right-aligned small-caps (e.g. date)
  actions?: React.ReactNode;
  className?: string;
}

export const Masthead: React.FC<MastheadProps> = ({ title, summary, meta, actions, className }) => (
  <header className={cn('mb-5', className)}>
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
      <h1 className="font-serif text-scale-5 font-medium text-ink">{title}</h1>
      <div className="flex items-center gap-3">
        {meta && <span className="cap-label">{meta}</span>}
        {actions}
      </div>
    </div>
    {summary && (
      <p className="mt-0.5 font-serif text-scale-1 italic text-ink-muted">{summary}</p>
    )}
    <div className="rule-double mt-2" />
  </header>
);
